<template>
	<div :class="{'border border-green border-md pa-2': debugMode}">
		<template v-if="debugMode">
			<div class="ao-p3-regular">MainOfDateRangePicker.vue</div>
			<pre
				class="mb-2"
				style="padding: 0.5rem; background-color: #3c3b3b; color: rgb(39, 136, 18); font-size: 12px;"
			><code>{{ {
				modelValue,
				date,
				min,
				max,
			} }}</code></pre>
		</template>
		<v-menu
			v-model="isShowMenu"
			:close-on-content-click="false"
			min-width="278"
			@update:modelValue="onUpdateIsShowMenuStatus"
		>
			<template #activator="{ props }">
				<ActivatorOfDateRangePicker
					v-model="isShowMenu"
					v-bind="props"
					:label="label"
					:placeholder="placeholder"
					:error="error"
					:errorMessages="errorMessages"
					:text="textOfActivator"
					:hideDetails="hideDetails"
				/>
			</template>
			<v-card
				class="ao-great-main-date-picker"
				style="overflow: unset;"
			>
				<div class="pa-2">
					<LayoutOfDateRangePicker
						:calendarHeight="calendarHeight"
						:showRangesList="false"
						:showHeader="false"
					>

						<template #calendar>
							<VueDatePicker
								:id="componentId"
								ref="DatePickerComponent"
								:modelValue="date"
								auto-apply
								:enable-time-picker="enableTimePicker"
								:min-date="min"
								:max-date="max"
								:model-type="enableTimePicker ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
								inline
								month-name-format="short"
								:locale="$i18n.locale"
								calendar-class-name="ao-great-date-picker-calendar"
								menu-class-name="ao-great-date-picker-menu"
								class="ao-great-date-picker"
								@update:modelValue="onUpdateDate"
							/>
						</template>

						<template #footer>
							<div class="d-flex">
								<ao-btn
									class="flex-grow-1"
									color="primary"
									variant="flat"
									@click="onClickApply"
								>
									{{ $t('Apply') }}
								</ao-btn>

								<ao-btn
									class="flex-grow-1"
									variant="text"
									@click="onClickCancel"
								>
									{{ $t('Cancel') }}
								</ao-btn>

								<!-- <ao-btn
									class="flex-grow-1"
									variant="text"
									@click="handleClearRanges"
								>
									Очистить даты
								</ao-btn> -->
							</div>
						</template>

					</LayoutOfDateRangePicker>
				</div>
			</v-card>
		</v-menu>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue'

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import useMoment from '@/composables/useMoment.js'

import ActivatorOfDateRangePicker from './ActivatorOfDateRangePicker.vue'
import LayoutOfDateRangePicker from './LayoutOfDateRangePicker.vue'

const props = defineProps({

	modelValue: {
		type: [Array, String],
		default: () => (null),
	},

	min: {
		type: String,
	},

	max: {
		type: String,
	},

	enableTimePicker: {
		type: Boolean,
		default: false,
	},

	label: {
		type: String,
	},

	placeholder: {
		type: String,
	},

	error: {
		type: Boolean,
		default: false,
	},

	errorMessages: {
		type: [Array, String],
		default: () => ([]),
	},

	hideDetails: {
		type: [Boolean, String],
		default: false,
	},

	debugMode: {
		type: Boolean,
		default: false,
	},

})

const emit = defineEmits([
	'update:modelValue',
	'blur',
])

const {
	formatDateTime,
} = useMoment()

const DatePickerComponent = ref(null)
const componentId = 'great-date-picker' + Math.random().toString(36).split('.')[1]
const calendarHeight = ref(null)

const isShowMenu = ref(false)

const onUpdateIsShowMenuStatus = (value) => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('onUpdateIsShowMenuStatus', value, isShowMenu.value)
	}
	if (value) {
		setDateFromProps()
	} else {
		emit('blur')
	}
}

const closeMenu = () => {
	isShowMenu.value = false
	emit('blur')
}

const date = ref(null)

const dateFormat = computed(() => {
	if (props.enableTimePicker) {
		return 'YYYY-MM-DD HH:mm:ss'
	}
	return 'YYYY-MM-DD'
})

const updateDate = (value) => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('updateDate', value)
	}
	if (!value) {
		date.value = null
		return
	}
	date.value = formatDateTime(value, dateFormat.value)
}

const setDateFromProps = () => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('setDateFromProps', props.modelValue)
	}
	updateDate(props.modelValue)
}

const onUpdateDate = (value) => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('onUpdateDate', value)
	}
	updateDate(value)
	// emit('update:modelValue', value)
}

const onClickApply = () => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('onClickApply')
	}
	emit('update:modelValue', date.value)
	closeMenu()
}

const onClickCancel = () => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('onClickCancel')
	}
	setDateFromProps()
	closeMenu()
}

const textOfActivator = computed(() => {
	if (!props.modelValue) {
		return null
	}

	const format = props.enableTimePicker ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'
	let dateTime = formatDateTime(props.modelValue, format)

	return dateTime
})

</script>

<style lang="scss">
.ao-great-main-date-picker {
	font-size: 12px;

	.ao-great-date-picker {
		.date-activator {
			width: 86px;
		}

	}

	.ao-great-time-picker {

		.time-activator {
			width: 52px;
		}

		.dp__action_button {
			font-size: 12px;
			outline: none;

			&.dp__action_cancel {
				border-color: rgba(var(--v-border-color), 0);

				&:hover {
					background-color: rgba(0, 0, 0, 0.04);
				}

			}

			&.dp__action_select {
				color: rgb(var(--v-theme-on-primary));
				background-color: rgb(var(--v-theme-primary));

				&:hover {
					background-color: rgba(var(--v-theme-primary), 0.9);
				}

			}

		}

	}

	.ao-great-date-picker,
	.ao-great-time-picker {
		width: auto;

		.dp__calendar {
			font-family: 'Inter', sans-serif;
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 150%;
		}

	}

	.date-activator,
	.time-activator {

		input {
			padding: 2px 4px;
			font-size: 12px;
			line-height: 18px;
			min-height: unset;
		}

	}

}

.ao-great-date-picker {

	.ao-great-date-picker-menu {
		border: none;
	}

	.dp__calendar {
		font-family: 'Inter', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 150%;
	}

}
</style>
